import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { getBuyerProductName, getProductName, getProductQty } from "../../../utils";
import CopyToClipboard from "../../../common/CopyToClipboard";


const ReqDetailsModal = (props) => {
    const { buyerReqDisplayProducts, isIncrementalReq } = props
    
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const brandData = useSelector((state) => state.common.materialBrands)

    return (
        <div className='req-details-modal mb-2 py-2'>
            <div className="grid">
                <div className="flex flex-row col-12 justify-content-between pb-0 pt-0">
                    {
                        isIncrementalReq ?
                        <div className="flex flex-row col-12 mb-2  md:col-12 lg:col-12 lg:mb-0 align-items-center justify-content-center">
                            <p className="m-0 quote-number ">Requirement will be created as below mentioned materials and respective quantities.</p>
                        </div>
                        :
                        <>
                            <div className="flex flex-row justify-content-start align-items-center col-12 md:col-4 lg:col-4 lg:mb-0 pl-0">
                                <h5 className="m-0 quote-number doc-no-navigation" style={{ fontSize: "13.76px"}}>Doc No: <span style={{ fontWeight: 100 }}>{buyerReqDisplayProducts[0]?.docNo}</span></h5>
                                {
                                    buyerReqDisplayProducts[0]?.docNo ? <CopyToClipboard text={buyerReqDisplayProducts[0]?.docNo} /> : ""
                                }
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-4 lg:col-4 lg:mb-0 align-items-center justify-content-center">
                                <h5 className="m-0 quote-number ">Doc date: <span style={{ fontWeight: 100 }}>{buyerReqDisplayProducts[0]?.createdAt}</span></h5>
                            </div>
                            <div className="flex flex-row col-12 mb-2  md:col-4 lg:col-4 lg:mb-0 align-items-center justify-content-end">
                                <h5 className="m-0 quote-number ">Order Type: <span style={{ fontWeight: 100 }}>{buyerReqDisplayProducts[0]?.orderType}</span></h5>
                            </div>
                        </>
                    }

                </div>
            </div>
            <div className="custom-table-container">
                <table className="custom-product-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="">
                            <th className="" >SR</th>
                            <th className={`${buyerReqDisplayProducts[0]?.orderTypeId !== 2 ? 'hidden-column' : ''}`} style={{ width: "5%" }}>Rate Contract Id</th>
                            <th className="" style={{ width: "10%" }}>Company ERP Code</th>
                            <th className="">Material Id</th>
                            <th className="" >Category</th>
                            <th className="" >Brand</th>
                            <th className="" style={{ width: "15%" }}>Product-Variant</th>
                            <th className="" style={{ width: "30%" }} >Specification</th>
                            <th className="" style={{ width: "10%" }}>Quantity</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            buyerReqDisplayProducts?.map((eachProductItem, index) => {
                                const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === eachProductItem?.categoryId)
                                const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === eachProductItem?.brandId)
                            
                                return (
                                    <tr key={`buyerReqItem-${eachProductItem.buyerReqItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="">{index + 1}</td>
                                        <td className={` ${eachProductItem?.orderTypeId !== 2 ? 'hidden-column' : ''}`}>{eachProductItem?.buyerRateContractId}</td>
                                        <td className="">{eachProductItem?.companyERPCode}</td>
                                        <td className="">{eachProductItem?.materialId}</td>
                                        <td className="">{relatedCategory?.categoryName}</td>
                                        <td className="">{relatedBrand?.brandName}</td>
                                        <td className="">{eachProductItem?.companyProdName ? getBuyerProductName(eachProductItem.companyProdName, eachProductItem.productName) : getProductName(relatedBrand.brandName, eachProductItem.productName, eachProductItem.variantName)}</td>
                                        <td className="">{eachProductItem?.companyProdSpec ? eachProductItem?.companyProdSpec : eachProductItem?.productSpecification }</td>
                                        <td className=""> {getProductQty(eachProductItem?.qty, eachProductItem?.UOM, eachProductItem?.UOMValue)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ReqDetailsModal;